import { useEffect } from 'react';

import { logger, LogType } from 'core/atoms/housekeeping';

import { Grid } from 'core/cells/grid';

import { AllergiesTable } from './components/allergies-table';

export const AllergiesListMainContent = () => {
  useEffect(() => {
    logger.debug({
      title: 'did mount',
      type: LogType.Info,
      logger: 'allergies-list-main-content',
    });
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <AllergiesTable />
      </Grid>
    </Grid>
  );
};
